import type { IFile } from '@/types/global';

import HTTP from '@/utils/http';

export const uploadService = {
  sendFile: (file: FormData) => HTTP.post<IFile>('upload', file).then(response => response.data),
};
